import React from 'react';

import Main from './main';

import {Helmet} from "react-helmet";

const Home = () => {
  return (
    <div id="home">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Планета Рыбака, всё для рыбалки</title>
        <link rel="canonical" href="http://rybalka.md.com" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      </Helmet>
      <Main />
    </div>
  );
};

export default Home;